@use 'src/global/mixins/icon' as icon;
@use 'src/global/variables';

leichte-sprache-free-text {
  &.is-disabled {
    cursor: not-allowed;
    background-color: ls-primary-color;
    form {
      input,
      button {
        background-color: ls-primary-color;
        cursor: not-allowed;
      }
    }
  }
  // This is needed for Safari, where the IE background-color fix color from ba-chatbot-component.scss
  // shines through around the edges of the input.
  background-color: ls-primary-color;
  form {
    display: flex;
    input {
      background-color: ls-primary-color;
      color: ls-text-color-dark;
      box-sizing: border-box;
      padding: 1.3rem 1rem;
      font-size: 16px; // To prevent auto zoom in on iPhones, we need font-size >= 16px
      width: 100%;
      border: none;
      &::placeholder {
        color: ls-text-color-dark;
      }
      &:focus {
        z-index: 1;
        outline: none;
        box-shadow: inset 0 0 0 3px ls-focus-color;
      }
    }
    button {
      padding: 0 1rem;
      background-color: ls-primary-color; // Needed on mobile
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center; // To center icon if font-size of body gets decreased a lot
      &:focus {
        z-index: 1;
        outline: none;
        box-shadow: inset 0 0 0 3px ls-focus-color;
      }
      i:before {
        font-size: 0.8rem;
        @include icon.icon;
        color: ls-text-color-dark;
        content: '\f119';
      }
    }
  }
}
